module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/EU-bdcc1872a234d00f57c3a3c261ee65aa.png";